module.exports = __webpack_public_path__ + "img/smile.292301d3.gif";